module.exports = __webpack_public_path__ + "img/qilin-f-stage3-hungry.6896e2ed.png";